import { Entry } from './pages';

export default {
  key: 'entry',
  isPrivate: false,
  exact: true,
  path: '/:token',
  component: Entry,
};
